<script lang="ts" setup>
import emitter from "@/utils/mitt";
import { onBeforeMount, watch } from "vue";
import VConsole from "vconsole";
import { useI18n } from "vue-i18n";
import { setDefaultFailToastOptions } from "@/stores/loading";
import { setNavbarBackground } from "@ht/utils";
import { useDarkMode } from "@/logics/init-dark-mode";
import { loadLocaleMessage } from "@/locales";

const { t, locale } = useI18n();

setDefaultFailToastOptions({
  message: t("frequentOperationsTryLater")
});

watch(locale, async newVal => {
  await loadLocaleMessage(newVal);
});

const initVconsoleTools = () => {
  if (__DEV__ || __LOCAL__ || __BETA__ || /vConsole/.test(location.href)) {
    const VC = new VConsole();
    const feedbackPlugin = new VConsole.VConsolePlugin(
      "cut_language",
      "语言切换"
    );
    const html = `<h1>点击下方按钮切换页面语言1</h1>`;
    feedbackPlugin.on("renderTab", (callback: (htmlDom: string) => void) => {
      callback(html);
    });
    const btnList: {
      name: string;
      global: boolean;
      onClick: (() => void) | (() => void) | (() => void);
    }[] = [];
    btnList.push({
      name: "阿语",
      global: false,
      onClick() {
        locale.value = "Arabic";
        VC.hide();
      }
    });
    btnList.push({
      name: "中文",
      global: false,
      onClick() {
        locale.value = "Chinese";
        VC.hide();
      }
    });
    btnList.push({
      name: "繁中",
      global: false,
      onClick() {
        locale.value = "Chinese_yy";
        VC.hide();
      }
    });
    btnList.push({
      name: "英文",
      global: false,
      onClick() {
        locale.value = "English";
        VC.hide();
      }
    });
    btnList.push({
      name: "法语",
      global: false,
      onClick() {
        locale.value = "French";
        VC.hide();
      }
    });
    btnList.push({
      name: "德语",
      global: false,
      onClick() {
        locale.value = "German";
        VC.hide();
      }
    });
    btnList.push({
      name: "印尼",
      global: false,
      onClick() {
        locale.value = "Indonesian";
        VC.hide();
      }
    });
    btnList.push({
      name: "意语",
      global: false,
      onClick() {
        locale.value = "Italian";
        VC.hide();
      }
    });
    btnList.push({
      name: "日语",
      global: false,
      onClick() {
        locale.value = "Japanese";
        VC.hide();
      }
    });
    btnList.push({
      name: "韩语",
      global: false,
      onClick() {
        locale.value = "Korean";
        VC.hide();
      }
    });
    btnList.push({
      name: "葡语",
      global: false,
      onClick() {
        locale.value = "Portuguese";
        VC.hide();
      }
    });
    btnList.push({
      name: "俄语",
      global: false,
      onClick() {
        locale.value = "Russian";
        VC.hide();
      }
    });
    btnList.push({
      name: "西语",
      global: false,
      onClick() {
        locale.value = "Spanish";
        VC.hide();
      }
    });
    btnList.push({
      name: "泰语",
      global: false,
      onClick() {
        locale.value = "Thai";
        VC.hide();
      }
    });
    btnList.push({
      name: "土耳",
      global: false,
      onClick() {
        locale.value = "Turkish";
        VC.hide();
      }
    });
    btnList.push({
      name: "越南",
      global: false,
      onClick() {
        locale.value = "Vietnamese";
        VC.hide();
      }
    });
    feedbackPlugin.on("addTool", callback => {
      callback(btnList);
    });
    VC.addPlugin(feedbackPlugin);
    VC.addPlugin(
      new VConsole.VConsolePlugin("darkMode", "切换暗黑")
        .on("renderTab", callback => {
          callback(
            `<div style="line-height: 200px; text-align: center">点击下方按钮切换暗黑模式</div>`
          );
        })
        .on("addTool", callback => {
          callback([
            {
              name: "切换暗黑",
              global: false,
              onClick() {
                const mode = useDarkMode();
                if (mode.isDarkMode) {
                  mode.enable();
                } else {
                  mode.disable();
                }
                try {
                  if (mode.isDarkMode) {
                    setNavbarBackground("#141414");
                  } else {
                    setNavbarBackground("#F7F7F7");
                  }
                } catch {
                  console.log("setNavbarBackground error: not in HT");
                }
                VC.hide();
              }
            }
          ]);
        })
    );
    VC.hide();
  }
};

onBeforeMount(() => {
  // 初始化VConsole
  initVconsoleTools();

  window.onReady = () => {
    console.log("onReady");
  };
  window.onShow = () => {
    console.log("onShow");
    emitter.emit("lifeOnShow");
  };
  window.onHide = () => {
    console.log("onHide");
    emitter.emit("lifeOnHide");
  };
  window.onUnload = () => {
    emitter.emit("onUnloadLife");
    console.log("onUnload");
    localStorage.removeItem("skipToGuide");
  };
});
</script>

<template>
  <RouterView v-slot="{ Component }">
    <Component :is="Component"></Component>
  </RouterView>
</template>
